<template>
    <div >
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item ><a @click="goBack">{{name}}</a></el-breadcrumb-item>
                        <el-breadcrumb-item>百科查看</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
                <el-divider></el-divider>
                <el-col :span="24">
                    <h1>{{wikiModel.KnowledgeTitle}}</h1>
                    <div>
                        <span style="margin-right:20px;">发布人：{{wikiModel.SendUserName}}</span>
                        <span>发布时间：{{wikiModel.SendTime}}</span>
                    </div>
                    <div v-html="content">
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<script>
    import { GetSingleKnowledge,GetKnowledgeContentDescry  } from "../../until/ZeusApiSDK/Logic/WikiLogic";
    import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";  
    import { ImageAddDomain,getUrlKey  } from "../../until/ZeusApiSDK/Logic/ImageStr";
    export default {
        data() {
          return {
            id:'',
            name:'',//头部名称
            content:'',//内容
            wikiModel:{},//单个百科影子信息
          };
        } ,
        methods: {
            //返回上一页
            goBack:function(){
                this.$router.go(-1)
            },
            //获取单个文章信息
            getSingleKnowledgeShadow:async function(){
                await GetSingleKnowledge(this.id).then(res=>{
                    this.wikiModel=res;
                    GetKnowledgeContentDescry(this.wikiModel.KnowledgeContent).then(res=>{
                        //如返回的文本含有图片则为图片添加域名
                        var data= ImageAddDomain(res,'http://e.ruizhiqi.com');
                        this.content=data;
                    });
                });
            },
        },
        //页面进入加载事件
        created:function(id){
            //获取地址栏id参数值
            this.id=getUrlKey('id');
            this.name=getUrlKey('name');
            //获取百科影子信息
            this.getSingleKnowledgeShadow();
        },
    }
</script>